import { Vue, Component, Prop } from 'vue-property-decorator'
import Form from '@/mixins/form'

@Component
export default class InputGroup extends Form {
  @Prop(String) name!: string

  created() {
    const parent = this.$parent as Form

    Vue.set(parent.validator.evaluators, this.name, this.validator)
    Vue.set(parent.validator.errors, this.name, false)
  }

  beforeDestroy() {
    const parent = this.$parent as Form
    Vue.delete(parent.validator.evaluators, this.name)
    Vue.delete(parent.validator.errors, this.name)
  }
}
